import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { StorageStrategy } from './storage.strategy'

@Injectable({ providedIn: 'root' })
export class LocalStorageStrategy extends StorageStrategy {
	getItem<T extends Record<string, any>>(key: string): Observable<T | null | undefined> {
		const value = localStorage.getItem(key)
		return of(value ? JSON.parse(value) : value)
	}
	setItem(key: string, value: Record<string, any>): Observable<any> {
		localStorage.setItem(key, JSON.stringify(value))
		return of(true)
	}
	removeItem(key: string): Observable<boolean | void> {
		localStorage.removeItem(key)
		return of(true)
	}
}
